import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './CustomDatePicker.scss'

interface IProps {
  startDate?: any,
  onChangeDate?: any,
  selected?: any
}

const CustomDatePickerContainer = ({
  startDate = '',
  onChangeDate
}:IProps) => {
  return <DatePicker selected={startDate} onChange={onChangeDate} />
}

export default CustomDatePickerContainer
